import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import LanguageDetector from 'i18next-browser-languagedetector';
// If you want to serve JSON files from your app bundle:
import authEn from "./locales/en/auth.json";
import sidebarEn from "./locales/en/sideBar.json";
import overviewEn from "./locales/en/overview.json";
import servicesEn from "./locales/en/services.json";
import globalEn from "./locales/en/global.json";
import staffEn from "./locales/en/staff.json";
import calendarEn from "./locales/en/calendar.json";
import rosterEn from "./locales/en/roster.json";
import searchEn from "./locales/en/search.json";
import paymentsEn from "./locales/en/payments.json";
import CancelAppointmentEn from './locales/en/cancelAppointment.json';
import bookingThemeEn from "./locales/en/bookingTheme.json";
import onlineBookingEn from "./locales/en/onlineBooking.json";
import bookingDetailsEn from "./locales/en/bookingDetails.json";
import bookingB2CEn from "./locales/en/bookingB2C.json";
import makeBookingEn from "./locales/en/makingBooking.json";
import clientSiteEn from "./locales/en/clientSite.json";
import miniSiteGeneralEn from "./locales/en/miniSiteGeneral.json";
import miniSiteEn from "./locales/en/miniSite.json";
import miniSiteThemeEn from "./locales/en/miniSiteTheme.json";
import miniSiteBusinessInfoEn from "./locales/en/miniSiteBusinessInfo.json";
import miniSiteSectionsEn from "./locales/en/miniSiteSections.json";
import miniSiteSocialsEn from "./locales/en/miniSiteSocials.json";
import supportEn from "./locales/en/support.json";
import settingsEn from "./locales/en/settings.json";
import policyEn from "./locales/en/policy.json"
import choosePlanEn from "./locales/en/choosePlan.json"
import marketingEn from "./locales/en/marketing.json"

import authEs from "./locales/es/auth.json";
import makeBookingEs from "./locales/es/makingBooking.json";
import choosePlanEs from "./locales/es/choosePlan.json"
import marketingEs from "./locales/es/marketing.json"
import sidebarEs from "./locales/es/sideBar.json";
import overviewEs from "./locales/es/overview.json";
import servicesEs from "./locales/es/services.json";
import globalEs from "./locales/es/global.json";
import staffEs from "./locales/es/staff.json";
import calendarEs from "./locales/es/calendar.json";
import rosterEs from "./locales/es/roster.json";
import searchEs from "./locales/es/search.json";
import paymentsEs from "./locales/es/payments.json";
import cancelAppointmentEs from "./locales/es/cancelAppointment.json";
import bookingThemeEs from "./locales/es/bookingTheme.json";
import onlineBookingEs from "./locales/es/onlineBooking.json";
import bookingDetailsEs from "./locales/es/bookingDetails.json";
import bookingB2CEs from "./locales/es/bookingB2C.json";
import clientSiteEs from "./locales/es/clientSite.json";
import miniSiteGeneralEs from "./locales/es/miniSiteGeneral.json";
import miniSiteEs from "./locales/es/miniSite.json";
import miniSiteThemeEs from "./locales/es/miniSiteTheme.json";
import miniSiteBusinessInfoEs from "./locales/es/miniSiteBusinessInfo.json";
import miniSiteSectionsEs from "./locales/es/miniSiteSections.json";
import miniSiteSocialsEs from "./locales/es/miniSiteSocials.json";
import supportEs from "./locales/es/support.json";
import settingsEs from "./locales/es/settings.json";
import policyEs from "./locales/es/policy.json";



i18n
  .use(ICU)               // plural rules, formatting
  .use(initReactI18next)
  .init({
    resources: {
      en: {  auth: authEn, sidebar: sidebarEn, overview: overviewEn, services: servicesEn, global: globalEn, staff: staffEn, calendar: calendarEn, roster: rosterEn, search: searchEn, payments: paymentsEn, cancelAppointment: CancelAppointmentEn, bookingTheme: bookingThemeEn, onlineBooking: onlineBookingEn, bookingDetails: bookingDetailsEn, bookingB2C: bookingB2CEn, makeBooking: makeBookingEn, clientSite: clientSiteEn, miniSiteGeneral: miniSiteGeneralEn, miniSite: miniSiteEn, miniSiteTheme: miniSiteThemeEn, miniSiteBusinessInfo: miniSiteBusinessInfoEn, miniSiteSections: miniSiteSectionsEn, miniSiteSocials: miniSiteSocialsEn, support: supportEn, settings: settingsEn, policy: policyEn, choosePlan: choosePlanEn, marketing: marketingEn},
      es: {
        auth: authEs,
        sidebar: sidebarEs,
        overview: overviewEs,
        services: servicesEs,
        global: globalEs,
        staff: staffEs,
        calendar: calendarEs,
        roster: rosterEs,
        search: searchEs,
        payments: paymentsEs,
        cancelAppointment: cancelAppointmentEs,
        bookingTheme: bookingThemeEs,
        onlineBooking: onlineBookingEs,
        bookingDetails: bookingDetailsEs,
        bookingB2C: bookingB2CEs,
        makeBooking: makeBookingEs,
        clientSite: clientSiteEs,
        miniSiteGeneral: miniSiteGeneralEs,
        miniSite: miniSiteEs,
        miniSiteTheme: miniSiteThemeEs,
        miniSiteBusinessInfo: miniSiteBusinessInfoEs,
        miniSiteSections: miniSiteSectionsEs,
        miniSiteSocials: miniSiteSocialsEs,
        support: supportEs,
        settings: settingsEs,
        policy: policyEs,
        choosePlan: choosePlanEs,
        marketing: marketingEs
      }
    },
    lng: 'en-GB',                  // default; we’ll override from backend
    fallbackLng: {
      'en-GB': ['en'],
      default: ['en']
    },
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ui.lang'
    }

  });

export default i18n;